import "./App.css";
import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import Header from "./pages/Header/Header";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import UserAccountPage from "./user page/UserAccountPage";
import { getAllUsers } from "./actions/users";
import Login from "./pages/Login/login";
import secureLocalStorage from "react-secure-storage";
import UserManagement from "./User Management/UserManagement";
import InternetConnectionMonitor from "./pages/Internet Connection/InternetConnection";
import { useLocation } from "react-router-dom";
import ResetPassword from "./pages/Login/ResetPassword";
import ResetMyPassword from "./user page/ResetPassword";
import NotFound from "./pages/Not Found/NotFound";
import { Toaster } from "react-hot-toast";
import AddUser from "./pages/AddUser/AddUser";
import EditUser from "./pages/Edit User/EditUser";
import SecuritySettings from "./pages/Security/SecuritySettings";
import { pickUpSharedLogin } from "./utils/sharedLogin";
function App() {
  const initialState = JSON.parse(secureLocalStorage.getItem("profile"));
  const [user, setUser] = React.useState(initialState);

  const location = useLocation();
  React.useEffect(() => {
    setUser(JSON.parse(secureLocalStorage.getItem("profile")));
  }, [location]);
  const dispatch = useDispatch();
  // Keyed on the user id, not the profile object: that is re-parsed on every
  // navigation and would refetch the users each time.
  const userId = user?.results?._id;
  React.useEffect(() => {
    if (userId) {
      dispatch(getAllUsers());
    }
  }, [dispatch, userId]);

  // Signed in to another app already? Pick that login up instead of showing
  // the login form (only admins are let in, as when signing in here).
  const [checkingLogin, setCheckingLogin] = React.useState(!initialState);
  React.useEffect(() => {
    if (initialState) return;
    pickUpSharedLogin().then((picked) => {
      if (!picked) setCheckingLogin(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (checkingLogin) return null;

  return (
    <div className="App">
      <Fragment>
        {user && <Header />}
        <Outlet />
        <InternetConnectionMonitor />
        <Routes>
          <Route
            path="/admin"
            element={user ? <UserManagement /> : <Login />}
          />
          <Route index element={user ? <UserManagement /> : <Login />} />

          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin/settings"
            element={user ? <UserAccountPage /> : <Login />}
          />
          <Route
            path="/admin/users/add"
            element={user ? <AddUser /> : <Login />}
          />
          <Route
            path="/admin/users/edit/:id"
            element={user ? <EditUser /> : <Login />}
          />
          <Route
            path="/admin/security"
            element={user ? <SecuritySettings /> : <Login />}
          />
          <Route path="/admin/resetPassword" element={<ResetPassword />} />
          <Route
            path="/admin/resetMyPassword/:token"
            element={<ResetMyPassword />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster
          position="top-center"
          gutter={12}
          containerStyle={{ margin: "8px" }}
          toastOptions={{
            success: {
              duration: 3000,
            },
            error: {
              duration: 6000,
            },
            style: {
              fontSize: "16px",
              maxWidth: "500px",
              padding: "12px 16px",
              backgroundColor: "#ffffff",
              color: "#6b7280",
            },
          }}
        />
      </Fragment>
    </div>
  );
}

export default App;
